export default __webpack_public_path__ + "static/media/TotalBooking.8ac61e54.svg";